module.exports = __webpack_public_path__ + "static/media/Latinghei-Extralight.ad2e5d9e.ttf";